import { BoxEntity } from "@modules/box/entities/boxEntity"
import { type BoxUserProgramItemDto } from "@modules/boxB2BProgram/gateway/boxB2BProgramDto"
import { PriceObjectEntity } from "@modules/common/priceObject/entities/priceObjectEntity"
import { convertImageFromDto } from "@modules/dtos/imageDto"
import { UserEntity } from "@modules/profile/userProfile/userEntity"
import { ProgramSubscriptionStatus, ProgramVisibility } from "@modules/programs/types/programTypes"
import { type HUImage } from "@modules/types/imageTypes"

export class BoxB2BSubscribedProgramsEntity {
  id: string
  name: string
  description: string
  image: HUImage | null
  owner: UserEntity | null
  visibility: ProgramVisibility
  subscribed: boolean
  subscriptionCount: number
  subscriptionStatus: ProgramSubscriptionStatus | null
  price: PriceObjectEntity | null
  subscribedByUser: UserEntity | null
  subscribedByBox: BoxEntity | null

  private constructor(entity: BoxB2BSubscribedProgramsEntity) {
    this.id = entity.id
    this.name = entity.name
    this.description = entity.description
    this.image = entity.image
    this.owner = entity.owner
    this.visibility = entity.visibility
    this.subscribed = entity.subscribed
    this.subscriptionCount = entity.subscriptionCount
    this.subscriptionStatus = entity.subscriptionStatus
    this.price = entity.price
    this.subscribedByUser = entity.subscribedByUser
    this.subscribedByBox = entity.subscribedByBox
  }

  static fromDto(dto: BoxUserProgramItemDto): BoxB2BSubscribedProgramsEntity {
    return new BoxB2BSubscribedProgramsEntity({
      id: dto.id,
      name: dto.name,
      description: dto.description,
      image: dto.image ? convertImageFromDto(dto.image) : null,
      owner: dto.owner ? UserEntity.fromDto(dto.owner) : null,
      visibility: dto.visibility,
      subscribed: dto.subscribed,
      subscriptionCount: dto.subscriptionCount,
      subscriptionStatus: dto.subscriptionStatus,
      price: dto.price ? PriceObjectEntity.fromDto(dto.price) : null,
      subscribedByUser: dto.subscribedByUser ? UserEntity.fromDto(dto.subscribedByUser) : null,
      subscribedByBox: dto.subscribedByBox ? BoxEntity.fromDto(dto.subscribedByBox) : null,
    })
  }
}
